export default "__VITE_ASSET__BMVW9LK9__"